import Vue from 'vue'
import Vuex, { mapState, mapGetters } from 'vuex'
import { Modal, Collapse } from 'buefy'
import store from '../store'
import Client from '../services/client'
import Results from '../components/eventsResults.vue'
import Pagination from '../components/calendarPagination.vue'
import Calendars from '../components/calendars.vue'
import Category from '../components/category.vue'

Vue.use(Vuex)
Vue.use(Modal)
Vue.use(Collapse)

function debounce (func, wait, immediate) {
  let timeout
  return function () {
    const context = this
    const args = arguments
    const later = function () {
      timeout = null
      if (!immediate) func.apply(context, args)
    }
    const callNow = immediate && !timeout
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
    if (callNow) func.apply(context, args)
  }
}

const el = document.querySelector('#events-app')
if (el !== null) {
  const vm = new Vue({
    store,
    components: {
      Calendars,
      Results,
      Pagination,
      Category,
      Modal,
      Collapse
    },
    data () {
      return {
        notifyIsOpen: false,
        isOpen: false,
        showCalendarToggle: true,
        windowWidth: window.innerWidth,
        section: 'events',
        siteId: null,
        preselected: [],
      }
    },
    delimiters: ['[[', ']]'],
    methods: {
      getCategories () {
        Client.getEventsCategories(this.variables)
          .then(response => {
            if (response.data.errors) {
              console.log(response.data.errors)
            } else {
              const data = response.data.data
              this.$store.commit('events/UPDATE_CATEGORIES', data.categories)
            }
          })
          .catch(error => {
            console.log(error)
          })
      },
      printPage () {
        window.print()
      },
      calendarsToggle () {
        this.isOpen = window.innerWidth > 768
        this.showCalendarToggle = window.innerWidth < 768
      },
      updateSection () {
        this.$store.commit('events/UPDATE_SECTION', this.section)
        if (this.section === 'athleticEvents') {
          this.$store.commit('events/UPDATE_LIMIT', 200)
        }
      },
      updateSelectedCategories () {
        if (this.preselected) {
          this.$store.commit('events/UPDATE_SELECTED_CATEGORIES', this.preselected)
        }
      },
      updateSiteId () {
        this.$store.commit('events/UPDATE_SITE_ID', this.siteId)
      },
      getResults () {
        Client.getEvents(this.variables)
          .then(response => {
            if (response.data.errors) {
              console.log(response.data.errors)
            } else {
              this.updateResults(response.data.data)
            }
          })
          .catch(error => {
            console.log(error)
          })
      },
      updateResults (data) {
        const currentPage = this.pageInfo.currentPage
        this.$store.commit('events/UPDATE_PAGEINFO', {
          currentPage: currentPage,
          hasPreviousPage: currentPage > 1,
          hasNextPage: true
        })
        this.$store.commit('events/UPDATE_RESULTS', data.entries)
      }
    },
    computed: {
      subQueryVals () {
        let string = ''
        if (this.queryCategories) {
          string = '?calendars=' + this.queryCategories
        }
        return string
      },
      ...mapState('events', ['categories', 'pageInfo']),
      ...mapGetters('events', ['queryCategories','variables'])
    },
    watch: {
      variables: function () {
        this.getResults()
      },
      queryCategories: function () {
        if (this.queryCategories.length) {
          console.log('has query categories')
          window.history.pushState(null, null, '?calendars=' + this.queryCategories)
        } else {
          window.history.pushState(null, null, window.location.pathname)
        }
      }
    },
    mounted () {
      window.addEventListener('resize', debounce(this.calendarsToggle, 100))
      const section = el.attributes['data-section'].value
      this.siteId = this.$el.attributes['data-site-id'].value
      this.section = section
      const preselected = this.$el.attributes['data-preselected'].value
      if (preselected) {
        this.preselected = preselected.split(',')
      }
      this.updateSiteId()
      this.updateSection()
      this.getCategories()
      this.updateSelectedCategories()
      this.calendarsToggle()
    },
    beforeDestroy: function () {
      window.removeEventListener('resize', this.calendarsToggle)
    },
  })
  vm.$mount(el)
}
